import { Flex, Box, Text } from "@chakra-ui/react";
import { MapPin } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { useCustomTheme } from "../../contexts/CustomThemeContext";

const DeliveryAddressButton = () => {
    const navigate = useNavigate();
    const { currentAddress } = useAuth();
    const { theme } = useCustomTheme();

    const accent = theme.brand?.electricBlue || theme.primary;

    return (
        <Flex
            align="center"
            gap={2}
            cursor="pointer"
            onClick={() => navigate("/delivery/address")}
            px={2}
            py={1.5}
            borderRadius="8px"
            transition="all 0.2s ease"
            role="group"
            _hover={{
                bg: theme.hover,
                transform: "translateY(-1px)",
            }}
        >
            <Box>
                <Text
                    fontSize="sm"
                    color={theme.text}
                    fontWeight={"500"}
                    transition="color 0.2s ease"
                    _groupHover={{ color: accent }}
                >
                    Set Delivery Address
                </Text>
            </Box>

            <Box
                as={MapPin}
                size={18}
                color={theme.text}
                fill="transparent"
                transition="all 0.2s ease"
                _groupHover={{
                    color: accent,
                    transform: "scale(1.05)",
                }}
            />
        </Flex>
    );
};

export default DeliveryAddressButton;